
/** @format */

import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageContainer, FilterPod, TableComponents } from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { useStyles } from './Style';
import useCustomHook from '../hooks';
import { Box, Grid } from '@mui/material';
import SubsetServices from '../services/SubsetServices';
import { columns, generateData } from './components/Columns';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

export default function SubsetList() {
  // -- STATES --//
  const tableRef = useRef();
  const {
    filters,
    setFilters,
    setFilterParams,
    loading,
    setLoading,
    page, setPage,
    size,
    setSize,
  } = useCustomHook();

  // --HOOKS--//
  const classes = useStyles();
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList =
    getDynamicObjectAction([
      'branchSubbusinessPage',
      'delegationSubbusinessPage',
      'detailSubbusinessPage',
      'updateSubbusinessPage'

    ]);
  const navigate = useNavigate();
  const onDetail = (rd) => {
    navigate('/SubBusiness/Detail', { state: { subset: rd } });
  };
  const onEdit = (rd) => {
    navigate(`/SubBusiness/${rd.id}`, { state: { branchInfo: rd } });
  };
  // --API REQUESTS--//
  const getSubsetsList = async (query) => {
    try {
      setLoading(true);
      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };

      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });

      const res = await SubsetServices.getSubsets(params);

      let list = [];
      list = generateData(res?.data?.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setLoading(false);
      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.data?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const hint =
    'در این بخش می‌توانید لیست کسب و کارهایی که به عنوان زیرمجموعه‌ی کسب و کار شما ثبت شده‌اند را مشاهده کنید.';

  return (
    <PageContainer
      title="زیرمجموعه‌های من"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.SUBBUSINESS_LIST}
      className={classes.root}
    >
      {actionsList['branchSubbusinessPage'] && (
        <>
          <Grid item xs={12}>
            <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>
          <TableComponents
            data={getSubsetsList}
            columns={columns(actionsList, navigate)}
            isLoading={loading}
            ref={tableRef}
            onChange={(ps) => {
              setPage(ps?.pageNumber)
              setSize(ps?.pageSize)
              return getSubsetsList(ps)
            }}
          />
        </>
      )}
    </PageContainer >
  );
}
